import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { ActionButton, DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { useBoolean } from '@fluentui/react-hooks';
import CTextBox from '../../../../Common/CTextBox';
import CDatePicker from '../../../../Common/CDatePicker';
import CTextAreaSimple from '../../../../Common/CTextAreaSimple';
import Picker from '../../../../Common/Picker';
import { Col, Row } from 'react-bootstrap';
import { __OBJECT_STRUCTURE_GetList } from '../../../../../common/ObjectStructures/Trasnversal';
import { __OBJECT_STRUCTURE_GetAction } from '../../../../../common/ObjectStructures/sKPI';
import List from '../../../../Templates/List';
import ListPagination from "../../../../Templates/List/ListPagination";
import { useGetListGapActions } from '../../../../../hooks/services/sKPI/useOfGAP';
import { saveActionsByElementId } from '../../../../../services/sKPI/gap.service';
import { useGetUsersMemberByElementId } from '../../../../../hooks/services/sKPI/useOfElement';
import moment from 'moment';
import { enum__GapActionTypes, __ActionStatus, __MessageTypes } from '../../../../../common/Dictionaries';
import GapActionCard from '../GapActionCard/GapActionCard';
import PropTypes from 'prop-types';
import MessageBox from '../../../../Common/Message/MessageBox';
import { isNullOrEmpty, showMessage } from '../../../../../common/Helpers';
import CValidator from '../../../../Common/CValidator';
import CLabel from '../../../../Common/CLabel';
import { Dropdown, ScrollablePane, ScrollbarVisibility } from '@fluentui/react';
import { cloneDeep } from 'lodash-es';

const SidePanelGeneralCommitments = (props) => {
    const { t } = useTranslation();

    const { 
        inputParam_GapAnalyzeId = null,
        inputParam_GapRevisionId = null,
        inputParam_GapElementId = null,
        inputParam_IsPanelOpen = null,
        inputParam_SetterIsPanelOpen = null,
        inputParam_EditMode = null,
    } = props;
    
    const [objIsValidForm, setObjIsValidForm] = useState({
        isInValidBeginDate      : false,
        isInValidEndDate        : false,
        isInvalidAction         : false,
        isInvalidTitle          : false,
        isInvalidOwner          : false,
        isInvalidExecutor       : false,
        isInvalidStatus   : false,
    })
    
    const [objAction, setObjAction] = useState(__OBJECT_STRUCTURE_GetAction());
    const [actionList, setActionist] = useState(__OBJECT_STRUCTURE_GetList());

    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [elementUserOwnerList, setElementUserOwnerList] = useState(null);
    useGetUsersMemberByElementId(inputParam_GapElementId, elementUserOwnerList, setElementUserOwnerList, false, [], inputParam_IsPanelOpen, false, true)
    
    const [elementUserExecutorList, setElementUserExecutorList] = useState(null);
    useGetUsersMemberByElementId(inputParam_GapElementId, elementUserExecutorList, setElementUserExecutorList, false, [], inputParam_IsPanelOpen, false, true)

    useGetListGapActions(inputParam_GapAnalyzeId, null, null, null, null, inputParam_GapRevisionId, actionList, setActionist, inputParam_IsPanelOpen)

    const actionStatusList = __ActionStatus.map(function(item) { return { key: item.key, text:  t(item.text) } });

    const validateForm = (obj) => {
        const isInvalidOwner = isNullOrEmpty(obj.owner);
        //const isInvalidExecutor = isNullOrEmpty(obj.executor);
        const isInvalidExecutor = false
        const isInvalidTitle = isNullOrEmpty(obj.title);
        const isInvalidAction = isNullOrEmpty(obj.action);

        const isInvalidStatus = obj.statusId <= 1 ? false : (isNullOrEmpty(obj.beginDate) || isNullOrEmpty(obj.endDate)) ;

        const isInvalidDateDifference1 = moment(obj.beginDate) > moment(obj.endDate);
        const isInvalidDateDifference2 = moment(obj.endDate) < moment(obj.beginDate);

        if (isInvalidDateDifference1) {
            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-startupperthanend'))
        }
        if (isInvalidDateDifference2) {
            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-endlowerthanstart'))
        }

        setObjIsValidForm({
            isInvalidAction     : isInvalidAction,
            isInvalidTitle      : isInvalidTitle,
            isInvalidOwner      : isInvalidOwner,
            isInvalidExecutor   : isInvalidExecutor,
            isInvalidStatus   : isInvalidStatus,
        })

        return !isInvalidOwner && !isInvalidExecutor && !isInvalidTitle && !isInvalidAction && !isInvalidStatus;
    };

    const onAddEditAction = (e) => {
        let formIsValid = validateForm(objAction);

        if (formIsValid === true) {

            if (objAction.id === null) {
                objAction.id = 0;
                objAction.statusId = 1;
                objAction.deactivate = false;
                objAction.gapAnalyzeId = inputParam_GapAnalyzeId;
                objAction.l_GapCauseId = [];
                objAction.l_gapRevisionId = [inputParam_GapRevisionId];
            }

            const aux_objAction = cloneDeep(objAction);
            aux_objAction.variableName = "";

            saveActionsByElementId(inputParam_GapAnalyzeId, [aux_objAction], enum__GapActionTypes.GAP_REVISION).then((response) => {
                if (response.data.succeeded) {
                    setActionist && setActionist(prevState => ({ ...prevState,
                        fireUpdate: true,
                        data : null
                    }));

                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            });
        } else {
            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-requireddatanotset'))
        }
    };

    const onEditActionFromListClick = (item) => {
        ManipulateRowButtonsDisplay(item.id)
        setObjAction({
            id: item.id,
            gapCauseId: item.gapCauseId,
            gapRevisionId: item.gapRevisionId,
            owner: item.owner,
            executor: item.executor,
            title: item.title,
            action: item.action,
            statusId: item.statusId,
            beginDate: item.beginDate,
            endDate: item.endDate,
        });

        let clear = false;
        setterUserFromListToForm(item, setElementUserOwnerList, 'username', 'owner', elementUserOwnerList, clear)
        setterUserFromListToForm(item, setElementUserExecutorList, 'username', 'executor', elementUserExecutorList, clear)
    }

    const setterUserFromListToForm = (item, setter, fieldFromList, fieldFromForm, list, clear) => {
        list.forEach(x => {
            x.checked = false;
            if (!clear) {
                if (x[fieldFromList] === item[fieldFromForm]) {
                    x.checked = item.checked !== undefined ? item.checked : true;
                }
            }
        })
        setter(list)
    }

    const onCancelRowClick = (item) => {
        ManipulateRowButtonsDisplay(item.id);
        setObjAction(__OBJECT_STRUCTURE_GetAction())

        let clear = true;
        setterUserFromListToForm(item, setElementUserOwnerList, 'username', 'owner', elementUserOwnerList, clear)
        setterUserFromListToForm(item, setElementUserExecutorList, 'username', 'executor', elementUserExecutorList, clear)
    };

    const ManipulateRowButtonsDisplay = (itemId) => {
        let elementsRowCancel = document.getElementsByClassName(`btnMantEdit`);
        let elementsRowEdit = document.getElementsByClassName(`btnMantCancel`);

        let elementBtnMantEdit = document.getElementById(`btnMantEdit${itemId}`);
        let elementBtnMantCancel = document.getElementById(`btnMantCancel${itemId}`);
        
        const isHiddenItem = elementBtnMantEdit.style.display === "none";

        if (isHiddenItem) {
            elementBtnMantCancel.style.display = "none";
            elementBtnMantEdit.style.display = "block";
        }
        else {
            Array.prototype.forEach.call(elementsRowCancel, function(el) {
                el.style.display = "block";
            });
            Array.prototype.forEach.call(elementsRowEdit, function(el) {
                el.style.display = "none";
            });

            elementBtnMantCancel.style.display = "block";
            elementBtnMantEdit.style.display = "none";
        }
    }

    const onDeleteActionFromListClick = (item) => {
        if (item.id > 0) {
            item.deactivate = true;

            const aux_objAction = cloneDeep(item);
            aux_objAction.variableName = "";

            saveActionsByElementId(inputParam_GapAnalyzeId, [aux_objAction], enum__GapActionTypes.GAP_REVISION).then((response) => {
                if (response.data.succeeded) {

                    setActionist(prevState => ({
                        ...prevState,
                        data: response.data.data
                    }));

                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            });
        }
        else {
            setActionist(prevState => ({
                ...prevState,
                data: actionList.data.filter(x => x.id !== item.id)
            }));
        }
    }

    const onHideDialog = (ev) => {
        ev.preventDefault();
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen && inputParam_SetterIsPanelOpen(false)
        showMessage(setMessageConfig, false, null, null)
        setActionist(__OBJECT_STRUCTURE_GetList())
        setObjAction(__OBJECT_STRUCTURE_GetAction())

        let clear = true;
        setterUserFromListToForm(null, setElementUserOwnerList, 'username', 'owner', elementUserOwnerList, clear)
        setterUserFromListToForm(null, setElementUserExecutorList, 'username', 'executor', elementUserExecutorList, clear)
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };
    
    const onClosePanel = () => {
        onDismissPanel();
    };

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12}>
                        <ListPagination
                            listLocalStoragePageSizeVariableName="viewAllActions"
                            data={ actionList }
                            setData={ setActionist } />
                    </Col>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        <MessageBox  
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </Col>
                    <Col xl={12}>
                        <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                    </Col>
                </Row>
    }

    const setterControlValue = (controlValue, controlName) => {
        setObjAction(prevState => ({
            ...prevState,
            [controlName]: controlValue,
        }));
        
        setObjIsValidForm(prevState => ({
            ...prevState,
            isInvalidTitle: controlValue === ""
        }));
    }

    const setterControlTextAreaValue = (e) => {
        const { value } = e.currentTarget; // <-- moved outside asynchronous context

        setObjAction(prevState => ({
            ...prevState,
            action: value,
        }));
        
        setObjIsValidForm(prevState => ({
            ...prevState,
            isInvalidAction: value === ""
        }));
    }

    const setterControlDatePickerValue = (value, controlName) => {
        if (controlName === "beginDate") {
            if (moment(value) > moment(objAction.endDate)) {
                showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-startupperthanend'))
            }
            else {
                setObjAction(prevState => ({
                    ...prevState,
                    [controlName]: moment(value).format("YYYY-MM-DDTHH:mm:ss.SSSZ")
                }));
            }

            setObjIsValidForm(prevState => ({
                ...prevState,
                isInValidBeginDate: isNullOrEmpty(value)
            }));
        }
        else if (controlName === "endDate") {
            if (moment(value) < moment(objAction.beginDate)) {
                showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-endlowerthanstart'))
            }
            else {
                setObjAction(prevState => ({
                    ...prevState,
                    [controlName]: moment(value).format("YYYY-MM-DDTHH:mm:ss.SSSZ")
                }));
            }

            setObjIsValidForm(prevState => ({
                ...prevState,
                isInValidEndDate: isNullOrEmpty(value)
            }));
        }
    }

    const onChangePickerOwner = (currentNode, selectedNodes) => {
        let clear = false;
        setterUserFromListToForm(currentNode, setElementUserOwnerList, 'username', 'username', elementUserOwnerList, clear)
        
        setObjAction(prevState => ({
            ...prevState,
            owner: currentNode.username
        }));

        setObjIsValidForm(prevState => ({
            ...prevState,
            isInvalidOwner: currentNode.username === ""
        }));

        showMessage(setMessageConfig, false, null, null)
    };

    const onChangePickerExecutor = (currentNode, selectedNodes) => {
        setObjAction(prevState => ({
            ...prevState,
            executor: currentNode.username
        }));

        let clear = false;
        setterUserFromListToForm(currentNode, setElementUserExecutorList, 'username', 'username', elementUserExecutorList, clear)

        setObjIsValidForm(prevState => ({
            ...prevState,
            isInvalidExecutor: currentNode.username === ""
        }));
        
        showMessage(setMessageConfig, false, null, null)
    };

    const onChangeActionState = (ev, item) => {
        setObjAction(prevState => ({
            ...prevState,
            statusId: item.key
        }));
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-generalcommitments') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                {
                    inputParam_EditMode &&
                    <>
                        <Row>
                            <Col xs={12} xl={6} className="mt-3">
                                <Picker
                                    data={ elementUserOwnerList !== null ? elementUserOwnerList : [] }
                                    mode="simpleSelect"
                                    className="dropdown-checkbox remove-position"
                                    texts={{ placeholder: t('data-lang-lbl-chooses') }}
                                    onChange={ onChangePickerOwner }
                                    labelText={ t('data-lang-lbl-responsible') }
                                    refresh={true}
                                />
                                <CValidator isInValid={ objIsValidForm.isInvalidOwner } />
                            </Col>
                            <Col xs={12} xl={6} className="mt-3">
                                <Picker
                                    data={ elementUserExecutorList !== null ? elementUserExecutorList : [] }
                                    mode="simpleSelect"
                                    className="dropdown-checkbox remove-position"
                                    texts={{ placeholder: t('data-lang-lbl-chooses') }}
                                    onChange={ onChangePickerExecutor }
                                    labelText={ t('data-lang-lbl-executor') }
                                    refresh={true}
                                />
                            </Col>
                            <Col xl={12} className="mt-3">
                                <CTextBox
                                    labelText={ t('data-lang-lbl-title') }
                                    controlValue={ objAction.title }
                                    textBoxName={'title'}
                                    maxLength={50}
                                    setterControlValue={setterControlValue}
                                />
                                <CValidator isInValid={ objIsValidForm.isInvalidTitle } />
                            </Col>
                            <Col xs={12} className="mt-3">
                                <CTextAreaSimple
                                    editMode={true}
                                    maxLength={250}
                                    labelText={ t('data-lang-lbl-action') }
                                    controlValue={ objAction.action } 
                                    textBoxName={'action'}
                                    setterControlValue={setterControlTextAreaValue}
                                />
                                <CValidator isInValid={ objIsValidForm.isInvalidAction } />
                            </Col>
                            <Col xs={12} xl={6} className="mt-3">
                                <CDatePicker 
                                    controlName={ "beginDate" } 
                                    controlValue={ objAction && objAction.beginDate } 
                                    setterControlValue={ setterControlDatePickerValue } 
                                    isInValid={ objIsValidForm.isInValidBeginDate } 
                                    labelText={ t('data-lang-lbl-startdate') } 
                                />
                            </Col>
                            <Col xs={12} xl={6} className="mt-3">
                                <CDatePicker 
                                    controlName={ "endDate" } 
                                    controlValue={ objAction && objAction.endDate } 
                                    setterControlValue={ setterControlDatePickerValue } 
                                    isInValid={ objIsValidForm.isInValidEndDate } 
                                    labelText={ t('data-lang-lbl-enddate') } 
                                />
                            </Col>
                        </Row>
                        {
                            objAction.id !== null && objAction.id !== 0 &&
                            <Row className='pt-2'>
                                <Col>
                                    <CLabel labelText={ t('data-lang-lbl-status') } />
                                    <Dropdown
                                        placeholder={t('data-lang-placeholder-selectoption')}
                                        options={actionStatusList}
                                        selectedKey={objAction.statusId}
                                        onChange={onChangeActionState}
                                        checkable
                                        styles={ {title: { height: "27px" }} }
                                        className="mb-1"
                                    />
                                    <CValidator isInValid={objIsValidForm.isInvalidStatus} isInvalidText={!objIsValidForm.isInvalidStatus ? "" : null} inValidText={t('data-lang-msg-actiondatesrequiredtochangestatus')} /> 
                                </Col>
                            </Row>
                        }
                        <Row className="mb-3">
                            <Col xl={12} className="mt-3">
                                <PrimaryButton onClick={onAddEditAction} text={(objAction.id === null || objAction.id === 0)? t('data-lang-btn-add') : t('data-lang-btn-edit')} />
                            </Col>
                        </Row>
                    </>
                }
                <ScrollablePane
                    styles={{
                        root: { height: "350px", position: "relative" },
                        contentContainer:{overflowX: "hidden"}
                    }}
                    scrollbarVisibility={ScrollbarVisibility.auto}
                    scrollContainerFocus={true}
                >
                    <List
                        listLocalStoragePageSizeVariableName="viewAllActions"
                        manipulateLocalData={ true }
                        setData={setActionist}
                        data={actionList}
                        showHeaders={false}
                        className="overflow-hidden no-compact-list"
                        columns={[
                            {  
                                key: 'title',
                                name: t('data-lang-lbl-data'),
                                fieldName: 'title',
                                onRender:(item, row) => {
                                    return <GapActionCard
                                                inputParam_EditMode={false}
                                                inputParam_GapElementId={inputParam_GapElementId}
                                                inputParam_ActionItem={item}
                                                inputParam_ShowSeparatorStyle={false}
                                                inputParam_GapAnalyzeId={inputParam_GapAnalyzeId}
                                                inputParam_GapRevisionId={inputParam_GapRevisionId}
                                            />
                                }
                            },{  
                                key: 'id',
                                name: t('data-lang-lbl-actions'),
                                fieldName: 'id',
                                onRender:(item, row) => {
                                    return  <>
                                            {
                                                inputParam_EditMode === true &&
                                                <div className='d-flex mt-3'>           
                                                    {
                                                        item.id > 0 && 
                                                        <>
                                                            <ActionButton className="btnMantEdit" id={`btnMantEdit${item.id}`} iconProps={{ iconName: 'Edit' }} onClick={() => onEditActionFromListClick(item)} allowDisabledFocus >
                                                            </ActionButton>
                                                            <ActionButton className="btnMantCancel" id={`btnMantCancel${item.id}`} style={{display: "none"}} iconProps={{ iconName: 'Cancel' }} onClick={() => onCancelRowClick(item)} allowDisabledFocus >
                                                            </ActionButton>
                                                        </>
                                                    }
                                                    <ActionButton id={`btnMantDelete${item.id}`} iconProps={{ iconName: 'Delete' }} onClick={() => onDeleteActionFromListClick(item)} allowDisabledFocus >
                                                    </ActionButton>
                                                </div>
                                            }
                                            </>
                                }
                            } 

                        ]}
                    />
                </ScrollablePane>  
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

SidePanelGeneralCommitments.propTypes = {
    inputParam_GapAnalyzeId: PropTypes.number.isRequired,
    inputParam_GapRevisionId: PropTypes.number.isRequired,
    inputParam_GapElementId: PropTypes.number.isRequired,
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
    inputParam_EditMode: PropTypes.bool.isRequired,
};

export default SidePanelGeneralCommitments;